import React, { useEffect, useState } from "react";
import { Modal, Form, Input, DatePicker, Button,Spin,notification } from "antd";
import 'antd/dist/reset.css';
import moment from 'moment';
import { showErrorNotification, showNotification, showWarningNotification } from '../../../util/documentConfig';
import { AddActivity,editActivity} from '../../../services/Service';
import activity from '../../../util/labels.json';
import { DATE_FORMAT } from "../../../constants";

const { RangePicker } = DatePicker;
 
 const AddNewActivity = ({ visible, setVisible, onCreate, onUpdate, selectedRecord }) => {
    const [form] = Form.useForm();
    const [isUpdated, setIsUpdated] = useState(false);
    const [loading, setLoading] = useState(false); 

    // Effect to configure notification settings
    useEffect(() => {
      notification.config({
        placement: 'topRight',
        top: 80,
        duration: 3,
        maxCount: 3
      });
    }, []);

    // Effect to handle form data population on record selection
    useEffect(() => {
      if (selectedRecord) {
        const activityDate = [
          moment(selectedRecord.activityStartDate,  DATE_FORMAT),
          moment(selectedRecord.activityEndDate,  DATE_FORMAT)
        ];
        form.setFieldsValue({
          ...selectedRecord,
          activityDate: activityDate.length === 2 ? activityDate : [],
        });
        setIsUpdated(false); // Reset update state on edit
      } else {
        form.resetFields(); // Reset form fields when there's no selected record
      }
    }, [form, selectedRecord]);
    
  
  
    /**
    * Handles form submission.
    * Validates and collects form values, formats the data, and triggers the appropriate callback.
    */
     const handleCreate = () => {
      setLoading(true); // Show spinner
      form.validateFields()
        .then((values) => {
          // Extract start and end dates from the date range
          const activityDate = values.activityDate || [];
          const [startDate, endDate] = activityDate.length === 2 ? activityDate : [null, null];
  
          // Prepare the payload for the API, excluding activityDate
          const { activityDate: _, ...restValues } = values;
          const jsonData = {
            ...restValues,
            activityStartDate: startDate ? startDate.format( DATE_FORMAT) : null,
            activityEndDate: endDate ? endDate.format( DATE_FORMAT) : null,
          };
  
          if (selectedRecord) {
            editActivity(jsonData, selectedRecord.id)
              .then(response => {
                if(response.ok)
                {
                showNotification(activity.updateSuccess);
                onUpdate(jsonData, selectedRecord);  // Update existing record, Pass values to parent function
                setVisible(false);
                }
                else{
                  const errorMessage = response.data.message || activity.updateFailed;
                  throw new Error(errorMessage);
                } // Close the modal after successful submission
              })
              .catch(error => {
                showErrorNotification(error.message);
              })
              .finally(() => {
                setLoading(false); // Hide spinner
              });
          } else {
            AddActivity(jsonData)
              .then(response => {
                if(response.ok)
                {
                showNotification(activity.addActivitySuccess);
                onCreate(jsonData);  // Create new record, Pass values to parent function
                form.resetFields();
                setVisible(false); 
                }
                else{
                  const errorMessage = response.data.message || activity.addActivityFailed;
                  throw new Error(errorMessage);
                } // Close the modal after successful submission
              })
              .catch(error => {
                showErrorNotification(error.message);
              })
              .finally(() => {
                setLoading(false); // Hide spinner
              });
          }
          setIsUpdated(false); // Reset the updated state after submitting
        })
        .catch((info) => {
          showWarningNotification(activity.dateValidationFailed);
          setLoading(false); // Hide spinner
        });
    };  
    
  
    /**
     * Handles modal close action.
     * Resets form if no record is selected and closes the modal.
     */
    const handleCancel = () => {
      if (!selectedRecord) {
        form.resetFields(); // Clear all form fields
      }
      setVisible(false); // Close modal
    };
  
    /**
     * Handles form field changes.
     * Enables the update button when a field is modified.
     */
    const handleValuesChange = () => {
      // Check if any field value is changed, if so, enable the Update button
      setIsUpdated(true);
    };
  
    // Set modal height to be less than the window height
    const modalHeight = window.innerHeight * 0.8; // 80% of the window height

    const disabledDate = (current) => {
      return current && current < moment().startOf('day');
  };

    return (
      <Modal
        open={visible}
        title={
          <div className="pt-2 pb-2 px-4 pl-0 rounded-lg sticky top-0 bg-white z-10">
            <span className="inline-block text-primary p-2 pl-0 text-xl">
            {selectedRecord ? activity.editActivity : activity.addNewActivity}  
            </span>
          </div>
        }
        okText={activity.saveActivity}
        onCancel={handleCancel}  // Use handleCancel to reset fields and close modal
        onOk={handleCreate}  // Submit form on OK
        okButtonProps={{
          className: "text-white border p-4 bg-[var(--color-primary)]",
          
        style: !isUpdated ? {
          color: 'white', // Set the text color to grey
          cursor: 'not-allowed', // Change the cursor to indicate the button is disabled
          opacity: 0.6 // Optional: Make the button appear slightly faded
        } : {},
  
          disabled: !isUpdated, // Disable the button if nothing has been updated
        }}
        cancelButtonProps={{
          className: "text-white border p-4 bg-[var(--color-primary)]"
        }}
        style={{
          width: '500px', // Fixed width
          height: '400px', // Fixed height
          maxHeight: '400px',
          overflowY: 'hidden', // Prevents the modal itself from scrolling
        }}
        maskClosable={false} // Prevents closing on outside click
      >
        <Spin spinning={loading}>
        <div className="modal-content-wrapper" style={{ maxHeight: 'calc(100vh - 300px)', overflowY: 'auto' }}>
          <Form form={form} layout="vertical" onValuesChange={handleValuesChange}>
            {/* Activity Name Field */}
            <Form.Item
              name="activityName"
              label={<span style={{ color: 'rgb(44, 87, 120)', fontWeight: 'bold' }}>{activity.activityNameTitle}</span>}
              rules={[{ required: true, message: activity.activityNameValidationMessage }]}
            >
              <Input className="w-full" />
            </Form.Item>
  
            {/* RangePicker Field */}
            <Form.Item
              label={<span style={{ color: 'rgb(44, 87, 120)', fontWeight: 'bold' }}>{activity.activityDateTitle}</span>}
              name="activityDate"
              rules={[{ required: true, message: activity.activityDateValidationMessage }]}
            >
              <RangePicker
                className="w-full"
                format="DD-MM-YYYY"
                disabledDate={disabledDate}
                // This disables manual editing
              />
            </Form.Item>
          </Form>
        </div>
        </Spin>
      </Modal>
    );
  };
export default AddNewActivity;